import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { GetOutpatientQuestionnaireEntryDetailDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { outpatientQuestionnaireEntryProfileDrawerState } from '~/state/reception/atoms';

export const useFetchOutpatientQuestionnaireEntry = () => {
  const { isOpen, outpatientQuestionnaireEntryId } = useAtomValue(
    outpatientQuestionnaireEntryProfileDrawerState,
  );
  const [getOutpatientQuestionnaireEntry, { data, loading }] = useLazyQuery(
    GetOutpatientQuestionnaireEntryDetailDocument,
    {
      fetchPolicy: 'network-only',
    },
  );

  const outpatientQuestionnaireEntry = getNode(data, 'OutpatientQuestionnaireEntry');

  useEffect(() => {
    if (isOpen && outpatientQuestionnaireEntryId) {
      getOutpatientQuestionnaireEntry({
        variables: {
          id: outpatientQuestionnaireEntryId,
        },
      });
    }
  }, [getOutpatientQuestionnaireEntry, isOpen, outpatientQuestionnaireEntryId]);

  return { outpatientQuestionnaireEntry, loading };
};
